import styled from "styled-components";
import { primaryColor } from "../../../../config/constants";

export const Container = styled.div`
  margin: 20px auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  justify-content: flex-start;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const NewMessageButton = styled.button`
  padding-left: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: none;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  cursor: pointer;
`;
export const NewMessageText = styled.p`
  margin-right: 20px;
  font-size: 14px;
  font-weight: bold;
  color: ${primaryColor};
`;
export const NewMessageImgContainer = styled.div`
  width: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 2px #e6e6e6 solid;
`;
export const NewMessageImg = styled.img`
  width: 20px;
  height: 20px;
`;
